import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
/*import {
	ChevronRightRounded,
	KeyboardArrowDownRounded
} from '@material-ui/icons';*/
// import AdminHeader from '../components/AdminHeader/AdminHeader';
import AdminSidebar from '../components/AdminSidebar/AdminSidebar';
import Branch from '../features/branch/Branch';
import Evaluator from '../features/evaluator/Evaluator';
import AdminSummary from '../features/adminSummary/AdminSummary';
import Reports from '../features/report/Report';

import { evaluatorListThunk } from '../features/evaluator/evaluatorSlice';
import { branchListThunk } from '../features/branch/branchSlice';
import { reportsThunk } from '../features/report/reportSlice';
import UserManagement from '../features/userManagement/UserManagement';
import ProjectManagement from '../features/projectManagement/ProjectManagement';
import OrganizationManagement from '../features/organisationManagement/OrganisationManagement';
import AssignmentManagement from '../features/assignmentManagement/AssignmentManagement';
import LocationManagement from '../features/locationManagement/LocationManagement';
import TaskManager from '../features/taskManager/TaskManager';
import QuestionsManagement from '../features/questionManagement/QuestionManagement';
import ManageReport from '../features/manageReport/ManageReport';
import BulkUpload from '../features/bulkUpload/BulkUpload';
import { Route, Routes, useNavigate } from 'react-router';
// import { AccountBoxRounded } from '@material-ui/icons';

const pages = [
	{
		id: 0,
		title: 'Summary',
		url:"summary",
		// icon: <HomeRounded />,
		page: <AdminSummary />,
	},
	{
		id: 1,
		title: 'Manage Reports',
		url:"manage-report",
		page: <ManageReport />,
	},
	// {
	// 	id: 2,
	// 	title: 'Manage Evaluators',
	// url:"evaluator",
	// 	page: <Evaluator />,
	// },
	// {
	// 	id: 3,
	// 	title: 'View Bank Branches',
	// 	url:"branch",
	// 	page: <Branch />,
	// },
	{
		id: 4,
		title: 'User Management',
		url:"user-management",
		page: <UserManagement />,
	},
	{
		id: 5,
		title: 'Management',
		url:"task-management",
		page: <TaskManager />,
	},
	{
		id: 6,
		title: 'Question Management',
		url:"question-management",
		page: <QuestionsManagement />,
	},
	{
		id: 7,
		title: 'Bulk Upload',
		url:"upload",
		page: <BulkUpload/>,
	},
	{
		id: 8,
		title: 'Logout',
		url:"logout",
		page: <Logout/>,
	},
	
];

const AdminDashboard = () => {
	const dispatch = useDispatch();
	dispatch(evaluatorListThunk());
	dispatch(branchListThunk());
	dispatch(reportsThunk());


    // get value from session storage, if null default to 0
	const [currentPageID, setCurrentPageID] = useState(
		/*sessionStorage.getItem('admPage') ? Number(JSON.parse(sessionStorage.getItem('admPage'))) :*/ 0
	);

	const setSelectedPageID = (id) => {
		setCurrentPageID(id);
		// persist selected page in session storage
		//sessionStorage.setItem('admPage', id);
	};

	return (
		<div>
			{/*<AdminHeader />*/}
			<div className="flex h-screen " >
				<AdminSidebar className='h-screen' pages={pages} setPage={setSelectedPageID} currentPage={currentPageID} />
				<div style={{ flex: '4' }} className="overflow-x-hidden m-4">
					{/* map through pages and only render page that matches id */}
							<div className="max-w-full">
							<Routes>
					<Route path="/" element={<AdminSummary />}/> 
					<Route path="/summary" element={<AdminSummary />}/> 
					<Route path="/manage-report" element={<ManageReport />}/> 
					<Route path="/evaluator" element={<Evaluator />}/> 
					<Route path="/branch" element={<Branch />}/> 
					<Route path="/user-management" element={<UserManagement />}/> 
					<Route path="/task-management" element={<TaskManager />}/> 
					<Route path="/question-management" element={<QuestionsManagement />}/> 
					<Route path="/upload" element={ <BulkUpload/>}/> 
					<Route path="/logout" element={ <Logout/>}/> 
					</Routes>	
							</div>
				</div>

				
			</div>
		</div>
	);
};

export default AdminDashboard;

function Logout(){
	const navigate= useNavigate()
useEffect(()=>{
	sessionStorage.clear()
navigate("/")
},[])
	return <>Logging out</>
}